import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDropdownChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 8,
	viewBox: "0 0 12 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 1L6 7L11 1",
		stroke: "#ADB6BD",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDropdownChevron;
